import React, { Component } from 'react';

import styles from './WelcomeScreen.module.css';

export default class WelcomeScreen extends Component {
	videoRefs = [];
	state = {
		showVideoIndex: null,
		videoPlaying: false,
		playGifIndex: null
	}

	controlVideo = (control, index) => {
		if (control === 'play' && !this.state.videoPlaying) {
			this.videoRefs[index].play();
			this.setState({ videoPlaying: true })
		}

		if (control === 'pause' && this.state.videoPlaying) {
			this.videoRefs[index].pause();
			this.setState({ videoPlaying: false })
		}

		if (control === 'vol-up' || control === 'vol-down') {
			let volume = this.videoRefs[index].volume;
			// the following if/else statements are used to make sure that the volume does not cross the set limit of [0.0, 1.0] or the app would crash
			if (volume === 1) {
				if (control === 'vol-up') volume = 1.0;
				else volume -= 0.1;
			}
			if (volume > 0 && volume < 1.0) {
				if (control === 'vol-up') volume += 0.1;
				else volume -= 0.1;
			}
			if (volume === 0) {
				if (control === 'vol-up') volume += 0.1;
				else volume = 0.0;
			}
			this.videoRefs[index].volume = volume.toPrecision(1);
		}
	}

	closeVideo = () => {
		this.setState({ showVideoIndex: null, videoPlaying: false })
		this.videoRefs.map(video => {
			video.pause();
			video.currentTime = 0;
			return null;
		});
	}

	getFirstAppComponents = () => {
		const landingImageSource = '/wp-content/plugins/terabit-matrix-game/assets/images/app1_landing_image.png';
		return (
			<div className={styles.LandingImageContainer}>
				<img src={landingImageSource} alt='MLMW_landing_image' className={styles.LandingImage} />
			</div>
		);
	}

	getSecondAppComponents = () => {
		const logoImageSource = '/wp-content/plugins/terabit-matrix-game/assets/images/mylearningmyway-logo1.png';
		let blocks = [], videos = [];
		for (let i = 0; i <= 22; i++) {
			const blockNumber = 'Block' + i;
			if (i === 2 || i === 5 || i === 9 || i === 16 || i === 19) {   // video blocks
				const blockClass = `${styles.VideoBlock} ${(this.state.showVideoIndex === i) ? styles.ShowVideo : ''}`
				const videoBlockNumber = 'Block-' + i + '-Video';
				const videoSrc = `/wp-content/plugins/terabit-matrix-game/assets/videos/block-${i}-video.mp4`;
				const imageSrc = `/wp-content/plugins/terabit-matrix-game/assets/images/video-snaps/block-${i}-snap.png`;
				const gifSrc = `/wp-content/plugins/terabit-matrix-game/assets/images/video-snaps/block-${i}-gif.gif`;

				const videoControls = (
					<div className={styles.VideoControlsContainer}>
						<div onClick={() => this.controlVideo('play', i)}>
							<i className="fa fa-play" />
						</div>
						<div onClick={() => this.controlVideo('pause', i)}>
							<i className="fa fa-pause" />
						</div>
						<div onClick={() => this.controlVideo('vol-down', i)}>
							<i className="fa fa-volume-down" />
						</div>
						<div onClick={() => this.controlVideo('vol-up', i)}>
							<i className="fa fa-volume-up" />
						</div>
					</div>
				);

				videos.push(
					<div key={`video-${i}`} className={`${styles.VideoContainer} ${styles[videoBlockNumber]} ${(this.state.showVideoIndex === i) ? styles.ShowVideo : ''}`} >
						<video width="100%" height="100%" ref={ref => this.videoRefs[i] = ref}>
							<source src={videoSrc} type="video/mp4" />
							Apologies, video playback is not supported on on your browser.
						</video>
						<div className={styles.CloseIconContainer} onClick={() => this.closeVideo()}>
							<i className={`fa fa-remove ${styles.CloseIcon}`} />
						</div>
						{videoControls}
					</div>
				)

				blocks.push(
					<div key={i} className={blockClass}>
						<img src={this.state.playGifIndex === i ? gifSrc : imageSrc} alt='video-snap' className={styles.BlockImage} />
						<div className={styles.PlayIconContainer}
						     onMouseOver={() => this.setState({ playGifIndex: i })}
						     onMouseOut={() => this.setState({ playGifIndex: null })}
						     onClick={() => {
						     	this.setState({ showVideoIndex: i });
						     	setTimeout(() => this.videoRefs[i].play(), 700)
						     }}>
							<i className={`fa fa-play-circle ${styles.PlayIcon}`}  />
						</div>
					</div>
				)
			} else if (i === 11) {  // for the logo in the center
				blocks.push(
					<div key={i} className={styles.LogoBlock}>
						<img src={logoImageSource} alt='MLMW_logo' className={styles.LogoBlockImage} />
					</div>
				)
			} else blocks.push(<div key={i} className={`${styles['Block']} ${styles[blockNumber]}`}/>)      // other blocks
		}

		return (
			<div className={styles.LandingBlocksContainer}>
				{blocks}
				{videos}
			</div>
		);
	}

	render() {
		const appNameHeading = <h3>{this.props.appName}</h3>;
		let welcomeScreen = null;
		if (this.props.currentApp === 'app-1') welcomeScreen = this.getFirstAppComponents();
		if (this.props.currentApp === 'app-2') welcomeScreen = this.getSecondAppComponents();
		if (this.props.currentApp === 'app-3') welcomeScreen = this.getFirstAppComponents();

		return (
			<div className={`${styles.WelcomeScreenContainer} ${this.props.showScreen ? '' : `${styles.HideScreen}`}`}>
				{welcomeScreen}
				<div className={'text-center'}>
					{appNameHeading}
					<div className={`${styles.LaunchAppBtn} ${styles[this.props.currentApp]}`} onClick={() => this.props.toggleScreenState()}>Launch App</div>
				</div>
			</div>
		);
	}
}